import React, { createContext, useContext, useReducer, useState } from "react";
import { spendReducer } from "./Reducer";

const RegisterContext = createContext();

const ContextProvider = ({ children }) => {
	const [activeStyle, setActiveStyle] = useState(1);
	// spend reducer to hold all the state and dispatch
	const [spendState, spendDispatch] = useReducer(spendReducer, {
		step1: false,
		step2: false,
		step3: false,
		step4: false,
	});

	// console.log(activeStyle);

	return (
		<RegisterContext.Provider
			value={{ activeStyle, setActiveStyle, spendState, spendDispatch }}
		>
			{children}
		</RegisterContext.Provider>
	);
};

export default ContextProvider;

// return the Register context
export const useRegisterContext = () => {
	return useContext(RegisterContext);
};
